import React from 'react';
import { Link } from 'react-router-dom';
import { Send } from 'lucide-react';

const SupplierCTA = () => {
  return (
    <div className="bg-brand/10 rounded-lg border border-brand/20 p-8">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
        <div>
          <h3 className="text-xl font-semibold text-content-primary mb-2">
            Want to get listed?
          </h3>
          <p className="text-content-secondary">
            Join our curated directory of industry suppliers and reach your target audience.
          </p>
        </div>
        <Link
          to="/advertising"
          className="whitespace-nowrap inline-flex items-center px-6 py-3 bg-brand hover:bg-brand-dark text-white rounded-lg transition-colors"
        >
          <Send className="w-4 h-4 mr-2" />
          Get Listed Here
        </Link>
      </div>
    </div>
  );
};

export default SupplierCTA;